<app-auth [isAtLeastMedium]="isAtLeastMedium">
  <div layout-body>
    <form novalidate class="mb-5" name="Fuser">
            <div class="login-content">
                <div *ngIf="!emailSentTo">
                    <div class="connect py-3">
                        <div class="icon-box info"><i class="fa fa-undo"></i>
                        </div>
                        <div class="header-content mt-4">
                            <div class="title-connect">Mot de passe oublié ?</div>
                        </div>
                    </div>   
                    <div class="header connect">
                        <div class="header-content">
                            <div class="subtitle">
                                Renseignez votre login et nous vous enverrons des instructions pour le réinitialiser
                            </div>

                            <form novalidate class="container-fluid" [hidden]="isValidated" class="login-content">
                                <div class="fields">
                                    <div class="forget">
                                        <stInput name="login" type="text" innerId="login" [(ngModel)]="login" placeholder="Votre login" class="custom-placeholder" ></stInput>
                                    </div>
                                    
                                    <div class="btn-full-width w-100">
                                        <stButton btnLabel="Réinitialiser mon mot de passe" btnClass="btn-color" [isDisabled]="!login" [hidden]="isValidated"
                                            (onClick)="validate()"></stButton>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div *ngIf="emailSentTo">
                    <div class="header connect">
                        <div class="icon-box info"><i class="fa fa-envelope small-icon"></i></div>
                        <div class="header-content">
                            <div class="title-connect mt-4">Consultez vos emails</div>
                            <div class="subtitle">
                                Si ce nom d'utilisateur existe, vous allez recevoir un nouveau mot de passe sur l'adresse mail associée.
                            </div>
                        </div>
                    </div>
                </div>
                <a routerLink="/" class="btn-connect btn-forget-pwd"><i class="fa fa-arrow-left size-arrow"></i>&nbsp; Se connecter</a>
            </div>
    </form>
  </div>
</app-auth>